import Config from "../Config";
import { Fragment, useRef, useState } from "react";

import xmenu from '../menu.png'
import xmenu_black from '../menu_black.png'

function EmployeeMainTop(props)
{
    const [tCounter, setTCounter] = useState(props.userData.max_session_sec);
    const [noticeReload, setNoticeReload] = useState(0);
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const showMenu = (e) => {
        props.mainView.changeMenuStatus(1);
    }
    
    const hideMenu = (e) => {
        props.mainView.changeMenuStatus(0);
    }

    var date = new Date(0);
    if(tCounter != undefined)date.setSeconds(tCounter); 
    var timeString = date.toISOString().substring(11, 19);

    var classDef = "";
    if(tCounter < 60)
    {
        classDef = "alert";
    }

    const reqRefresh = () => {

      
        setTCounter( tCounter - 1 );        
        
                var b5 = tCounter % 10;


                if(b5 == 0  )
                {        
                            var dt = { 
                                'clock': tCounter,
                                'version': Config.app_version,
                             }

            
                            fetch( Config.url + '/rest_v1,refresh', {
                                method: 'POST', 
                                body: JSON.stringify(dt), 
                                headers: {
                                    'Content-Type': 'text/html',
                                    'X-API-KEY': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => {                                           
                            
                                

                                if(res.ERROR != undefined )
                                {
                                    
                                    if(res.ERROR == 'logout' || res.ERROR == 'LOGOUT')
                                    {
                                        //props.mainView.logout();
                                        localStorage.clear();
                                        sessionStorage.clear();

                                        props.mainView.showDialog("Ups!", "Sesja została zakończona", "ok", (option)=>{

                                            document.location.href = "/?msg=logout";

                                        })
                                    }
                                }

                                if(res.status != null && res.status != undefined)
                                {


                                       if(   (res.status == 'ask_reload' || res.status == 'ASK_RELOAD') && noticeReload == 1 )
                                        {
                                            //zapytaj i przeładuj..
                                            setNoticeReload(1);
                                        }

                                        if(res.status == 'reload' || res.status == 'RELOAD' )
                                        {
                                            window.location.reload();
                                        }

                                        if(res.status == 'logout' || res.status == 'LOGOUT')
                                        {
                                             props.mainView.logout();
                                             window.location.reload();
                                        }

                                        if(res.status == 'OK' || res.status == 'ok' )
                                        {
                                            if(props.mainView.refreshHandle != null ) props.mainView.refreshHandle();

                                            if(res.global != undefined)  //ilosc nowych dzieci w rekrutacji..
                                            {
                                               // props.mainView.setGlobal();
                                        
                                               var tmpGlobal = new Object();

                                               for (const [key, value] of Object.entries(res.global)) {                                                    
                                                 // props.mainView.setGlobal(  key, value );
                                                   tmpGlobal[key] = value;
                                                }

                                                props.mainView.setGlobal(  '_x_', tmpGlobal );
                                            }

                                            if(res.p_przedszkole_id != undefined)
                                            {
                                                        if(props.userData.p_przedszkole_id > 0 && res.p_przedszkole_id != props.userData.p_przedszkole_id )                                                            
                                                        {
                                                            props.mainView.showDialog("Potwierdź", "Placówka została zmieniona", "ok", (option)=>{
                    
                                                                        ///--------
                                                                         window.location.reload();
                                                                        //--------
                                                                } );
                                                        }
                                            }

                                            if(res.p_dziecko_id != undefined)
                                                {
                                                        //console.log("D.", res.p_dziecko_id, props.userData.p_dziecko_id  );

                                                        if(props.userData.p_dziecko_id > 0 && res.p_dziecko_id != props.userData.p_dziecko_id )                                                            
                                                            {
                                                                props.mainView.showDialog("Potwierdź", "Profil dziecka został zmieniony", "ok", (option)=>{
                        
                                                                            ///--------
                                                                             window.location.reload();
                                                                            //--------
                                                                    } );
                                                            }
                                                }


                                            if(res.msgs != null)
                                            {
                                                for(var xk=0; xk < res.msgs.length; xk++)
                                                {
                                                    var mTitle = res.msgs[xk].title;
                                                    var mMsg   = res.msgs[xk].msg;

                                                    props.mainView.showDialog( mTitle ,  mMsg  ,  "ok"  ,null); 
                                                }
                                            }

                                        }


                                        if(res.status == 'VERSION' || res.status == 'version')
                                            {

                                                var ts = new Date() / 1000;

                                                var lastTs =  props.mainView.readFilter('version_app',  -1 );
                                                var diffTs = 0;

                                                if(lastTs > 0)
                                                {
                                                    diffTs =  parseFloat( ts) -  parseFloat(lastTs) ;
                                                }

                                                //console.log(lastTs, ts, diffTs);

                                                if(diffTs  > 120 || diffTs == 0)
                                                {
                                                        props.mainView.writeFilter('version_app',ts );
                                                    
                                                        props.mainView.showDialog("Potwierdź", "Panel wymaga aktualizacji. Czy chcesz teraz przeładować stronę?", "yesno", (option)=>{
            
                                                            ///--------
                                                            if(option == "yes")  window.location.reload();
                                                            //--------
                                                    } );
                                              }


                                            }

                                    
                                }
                                
                            } )
                            .catch(err => {
                                console.log("Err " + err);
                            });                                    
                }//b5 = 0

   }

    if(refreshView != props.userData.refreshView)
    {
        //props.userData.max_session_sec
        
        setRefreshView(props.userData.refreshView);
        setTCounter(props.userData.max_session_sec);
    }

    if(window.internalID == null || window.internalID == undefined)
    {          
        window.internalID =  setInterval(reqRefresh, 1000 );
    }else
    {
        clearInterval( window.internalID );
        window.internalID =  setInterval(reqRefresh, 1000 );
    }

    return( 
        
        <div class="menu_top">
            
            &nbsp;   
                           {
                               props.mainView.menuSelected != "men" &&
                               <Fragment>
           
           
                                   {
                                       props.mainView.menuVisible == 0 &&
                                       <div className="menu_show_btn link_normal mobile_hide_now " onClick={showMenu}>
                                           <img src={xmenu} className="img_white" />
                                           <img src={xmenu_black} className="img_black" />
                                           </div>
                                   }
           
                                   {
                                       props.mainView.menuVisible == 1 &&
                                       <div className="menu_show_btn link_normal mobile_hide_now" onClick={hideMenu}  >
                                           <img src={xmenu} className="img_white" />
                                           <img src={xmenu_black} className="img_black" />
                                           </div>
                                   }
           
           
           
                                   <div className="menu_show_btn2 link_normal link_men nohide_mobile"  module="men" view="start" id="xt_men" onClick={props.mainView.quickGo } >&nbsp;<span className="men_btn"></span>&nbsp;idź do: e-dziennika&nbsp;</div>                                                            
                               </Fragment>
                           }
                        
                           &nbsp;   
                           {
                               props.mainView.menuSelected == "men" &&
                               <Fragment>
                                   <div className="menu_show_btn2 link_normal link_men nohide_mobile"  module="home" view="start" id="xt_xt" onClick={props.mainView.quickGo } >&nbsp;<span className="men_btn"></span>&nbsp;wróć do: eLizaka&nbsp;</div>                                                           
                               </Fragment>
                           }



        <div className="mtop_item popup mobile_hide" title="Wyloguj z systemu">
            &nbsp; &nbsp;  {props.userData.name} {props.userData.last_name}  &nbsp; &nbsp;
            <div className="windows_popup">                         
                <div className="windows_view">
                    <div className="pl_item">
                        <div className="pl_img pl_link " onClick={props.mainView.logout}>
                            {props.userData.dic.logout}
                        </div>                                                                                                      
                    </div>
                    <div className="pl_item">
                        <div className="pl_img pl_link " module="homeE" view="account" id="" onClick={props.mainView.quickGo}>
                            {props.userData.dic.account}
                        </div>                                                                                                      
                    </div>
                </div>
            </div>
        </div>   



        <div className="mtop_item mobile_hide" title="Koniec sesji za">{props.userData.dic.toend}: <span className={classDef}   >{timeString} </span></div>

        <div className="mtop_item mobile_hide" >
        &nbsp; &nbsp;
        </div>    

        </div>
    )
}


export default EmployeeMainTop;